import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getStartCalendar = (state: StateScheme) => {
    return state.finance.startCalendar
}
